import EntityMember from "_shared/entity-members/entity-member";
import Guid from "_shared/guids/guid";
import Name from "_shared/names/name";

export default class SelectedVendorTeamLeader {
  public static fromURLSearchParams(params: URLSearchParams): SelectedVendorTeamLeader | undefined {
    const userIdParam = params.get("tUserId");
    const entityIdParam = params.get("tEntityId");
    const isClientRepParam = params.get("tIsClientRep");
    const isVendorRepParam = params.get("tIsVendorRep");
    const firstNameParam = params.get("firstName");
    const lastNameParam = params.get("lastName");

    if (!userIdParam || !entityIdParam || !isClientRepParam || !isVendorRepParam || !firstNameParam || !lastNameParam) {
      return undefined;
    }

    return new SelectedVendorTeamLeader({
      userId: new Guid(userIdParam),
      legalEntityId: new Guid(entityIdParam),
      isClient: isClientRepParam === "true",
      isVendor: isVendorRepParam === "true",
      name: Name.create({ params: { firstName: firstNameParam, lastName: lastNameParam } }),
    });
  }
  public readonly userId: Guid;
  public readonly legalEntityId: Guid;
  public readonly name: Name;
  public readonly isClientRep: boolean;
  public readonly isVendorRep: boolean;

  constructor(params: { userId: Guid; legalEntityId: Guid; isClient: boolean; isVendor: boolean; name: Name }) {
    this.userId = params.userId;
    this.legalEntityId = params.legalEntityId;
    this.name = params.name;
    this.isClientRep = params.isClient;
    this.isVendorRep = params.isVendor;
  }

  public generateTargetUrl(action: "create" | "request", location: Location): URL {
    let url = new URL(`/proposals/drafts/${action}`, location.origin);
    url.searchParams.append("tUserId", this.userId.value);
    url.searchParams.append("tEntityId", this.legalEntityId.value);
    url.searchParams.append("tIsClientRep", this.isClientRep.toString());
    url.searchParams.append("tIsVendorRep", this.isVendorRep.toString());
    url.searchParams.append("firstName", this.name.firstName?.toString() ?? "");
    url.searchParams.append("lastName", this.name.lastName?.toString() ?? "");

    return url;
  }

  public toJSON(): Record<string, unknown> {
    return {
      userId: this.userId.value,
      legalEntityId: this.legalEntityId.value,
      isClientRep: this.isClientRep,
      isVendorRep: this.isVendorRep,
      name: this.name.toJSON(),
    };
  }
  public toEntityMember(): EntityMember {
    return new EntityMember({
      userId: this.userId,
      legalEntityId: this.legalEntityId,
    });
  }
}
